const Logo = ({ className = "", strokeWidth = 1.5 }) => {
    return (
        <svg className={className} width="23" height="28" viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 8.4V26M21 8.4C21 5.73333 19.1 2 11.5 2C3.9 2 2 7.33333 2 10M21 8.4C21 11.6 19.1 14.8 11.5 14.8C8.33333 14.8 2 15.76 2 19.6M2 24.4V26" />
        </svg>

    )
}

export default Logo